import NumericFilter from './NumericFilter';
import AutoCompleteFilter from './AutoCompleteFilter';
import MultiSelectFilter from './MultiSelectFilter';
import SingleSelectFilter from './SingleSelectFilter';

const Filters = {
  NumericFilter: NumericFilter,
  AutoCompleteFilter: AutoCompleteFilter,
  MultiSelectFilter: MultiSelectFilter,
  SingleSelectFilter: SingleSelectFilter,
};

module.exports = Filters;
